/**
 * OCR testing destination: test cases and runs, each a section of the bar
 * under the app bar, with their create and detail pages below them.
 */

import React from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';
import { TestCasesList } from './TestCasesList';
import { TestCaseCreate } from './TestCaseCreate';
import { TestCaseDetail } from './TestCaseDetail';
import { TestRunsList } from './TestRunsList';
import { TestRunDetail } from './TestRunDetail';

export const OcrTestingPage: React.FC = () => (
  <Routes>
    <Route index element={<Navigate to="cases" replace />} />
    <Route path="cases" element={<TestCasesList />} />
    <Route path="cases/new" element={<TestCaseCreate />} />
    <Route path="cases/:id" element={<TestCaseDetail />} />
    <Route path="runs" element={<TestRunsList />} />
    <Route path="runs/:id" element={<TestRunDetail />} />
  </Routes>
);
